import { useQuery } from '@apollo/client/react';
import { BusinessOutcomesType } from '../types';
import { MilestonesType } from '../../milestones/types';
import { RisksType, Budget } from 'domain/shared/newProject';
import { GET_OUTCOMES_TAB_DATA } from '../graphql/outcomesQueries';
import { NetworkStatus } from '@apollo/client';

export interface ProjectOutcomesResponse {
  id: string | number;
  businessOutcomes: BusinessOutcomesType[];
  milestones: MilestonesType[];
  risks: RisksType[];
  budget: Budget;
}

export const useProjectOutcomes = (id: string | number) => {
  const { data, loading, error, refetch, networkStatus } = useQuery<{ baseProject: ProjectOutcomesResponse }>(
    GET_OUTCOMES_TAB_DATA,
    {
      variables: { id: id.toString() },
      skip: !id,
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    },
  );

  return {
    data: data?.baseProject,
    loading,
    isDataReloading: networkStatus !== NetworkStatus.ready,
    error,
    refetch,
  };
};
